import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

const useValidatePassword = () => {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'changePassword.validatePasswordMessage',
  });

  return {
    minLength: (value: string) => value.length >= 8 || t('minLength'),
    hasUpperCase: (value: string) => /[A-Z]/.test(value) || t('hasUpperCase'),
    hasLowerCase: (value: string) => /[a-z]/.test(value) || t('hasLowerCase'),
    hasNumber: (value: string) => /\d/.test(value) || t('hasNumber'),
    hasSpecialChar: (value: string) =>
      /[!@#$%^&*()_+\-={}[\]:";'<>,./]/.test(value) || t('hasSpecialChar'),
  };
};

export default useValidatePassword;
